import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import backicon from '../../../../Assets/icons/backIcon.svg';
import DynamicForm from '../../../customformComponent/customForm/DynamicForm';
import axiosInstance from '../../../services/api/API';
import './CreateOrder.scss';
import CustomTable from '../../../customComponents/CustomTable';
import editIcon from '../../../../Assets/icons/Un-Checkbox.svg';
import deleteIcon from '../../../../Assets/icons/trash.svg';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaCalendarAlt } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { buttonStyle, isFormValid } from '../../../../helpers/common';

const GenerateOrder = () => {
  const [validationErrors, setValidationErrors] = useState({});
  const [variantOptions, setVariantOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);
  const [formData, setFormData] = useState({});
  const [itemCategoryOption, setItemcategoryOptions] = useState([]);
  const [accessoryOptions, setaccessoryOptions] = useState([]);
  const [draftId, setDraftId] = useState(0);
  const [isEdit, setIsEdit] = useState(false);

  // Table data states
  const [remarkData, setRemarkData] = useState();
  const [productData, setProductData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [totalActive, setTotalActive] = useState(0);

  // Modal for expected Date
  const [expectedDate, setExpectedDate] = useState('');
  const [formattedDate, setFormattedDate] = useState('');
  const [acceptModal, setAcceptModal] = useState(false);
  const [dealerOption, setDealerOptions] = useState([]);

  const dealer_id = localStorage.getItem('dealerId');
  const engineer_id = localStorage.getItem('engineer_id');
  const UserType = localStorage.getItem('UserType');

  const location = useLocation();
  const { jobCardDataDetails } = location.state || {};

  const datePickerRefs = useRef({}); // Reference for DatePicker
  const isPopulatingEdit = useRef(false);

  const handleChange = (fieldName, date) => {
    // Format the date to "dd/MM/yyyy" and update state
    const formattedDate = date
      ? date.toLocaleDateString('en-GB').replace(/\//g, '/')
      : '';
    setExpectedDate(formattedDate);
  };

  const openDatePicker = (fieldName) => {
    // Open DatePicker when icon is clicked
    if (datePickerRefs.current[fieldName]) {
      datePickerRefs.current[fieldName].setFocus();
    }
  };

  const handleAcceptModalOpen = () => {
    setAcceptModal(true);
  };

  const closeAcceptModal = () => {
    setExpectedDate('');
    setAcceptModal(false);
  };

  const navigate = useNavigate();
  const token = localStorage.getItem('authToken');

  const handleDraftSubmit = async () => {
    console.log('clicked');
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to save this draft?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axiosInstance.post(
            '/purchaseorder/create',
            {
              is_order_accepted: 6,
              po_expected_date: null,
              po_item_type: 'V',
            },
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (response.status === 200) {
            navigate('/manage-sales/manage-order');
          }
        } catch (error) {
          console.error('Error adding dealer:', error);
          const errorMessage = error.response?.data?.message;
          console.log(errorMessage, 'errorMessage');
          Swal.fire({
            title: 'Error',
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: 'Cancelled',
          text: 'This record was not added into draft.',
          icon: 'info',
          confirmButtonText: 'OK',
        });

        // setLoading(false);
      }
    });
  };

  const handleSubmit = async () => {
    if (!expectedDate) {
      Swal.fire({
        title: 'Expected Date Required',
        text: 'Please enter the expected date before creating the order.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return; // Stop execution
    }

    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to create this order?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axiosInstance.post(
            '/purchaseorder/create',
            {
              po_expected_date: expectedDate,
              is_order_accepted: 0,
              po_item_type: 'V',
            },
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            },
          );

          // if(response.status === 200){
          //   navigate("/manage-sales/manage-order")
          // }

          if (response.status === 200) {
            Swal.fire({
              title: 'Success',
              text: 'Thanks for your confirmation',
              icon: 'success',
              confirmButtonText: 'OK',
            }).then(() => {
              // navigate("/manage-sales/manage-order");
              navigate(-1);
            });
          }
        } catch (error) {
          console.error('Error adding dealer:', error);
          const errorMessage = error.response?.data?.message;
          console.log(errorMessage, 'errorMessage');
          Swal.fire({
            title: 'Error',
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: 'Cancelled',
          text: 'This record was not added into draft.',
          icon: 'info',
          confirmButtonText: 'OK',
        });

        // setLoading(false);
      }
    });
  };

  useEffect(() => {
    const colorId = formData.color;
    const modelId = formData.model;

    if (colorId && modelId) {
      fetchVariantOptions(colorId, modelId);
    }
  }, [formData.color, formData.model]);

  const fetchVariantOptions = async (colorId, modelId) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/variant/ddlvariant',
        {
          color_id: colorId,
          model_id: modelId,
          dealer_id: dealer_id,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error('Error fetching variant options:', error);
    }
  };

  useEffect(() => {
    const variantId = formData.variant;

    if (variantId) {
      fetchVariantBasedDetails(variantId);
    }
  }, [formData.variant]);

  const fetchVariantBasedDetails = async (variantId, index) => {
    const isPopulating = isPopulatingEdit.current;
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/variant/ddlvariantbasedetails',
        { variant_id: variantId },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const variantData = response?.data?.data?.data[0];
      console.log(variantData, 'variantData');

      if (formData.itemType === 'V') {
        if (!isPopulating) {
          setFormData((prevData) => ({
            ...prevData,
            // color: variantData.color_name,
            warranty: variantData?.warranty_name,
            basePrice: variantData?.dealer_price,
            tax: variantData?.tax_percent,
            remark: variantData?.remark,
          }));
        }

        setRemarkData(variantData?.remark);
      }
    } catch (error) {
      console.error('Error fetching variant-based details:', error);
    }
  };

  useEffect(() => {
    const itemTypeVal = formData.itemType;
    const variantId = formData.variant;

    if (itemTypeVal && variantId) {
      fetchItemCategoryOptions(itemTypeVal, variantId);
    }
  }, [formData.itemType, formData.variant]);

  const fetchItemCategoryOptions = async (itemTypeVal, variantId) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/partcategory/ddlpartcategory',
        {
          itemtype: itemTypeVal,
          variant_id: variantId,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setItemcategoryOptions(options);
    } catch (error) {
      console.error('Error fetching variant options:', error);
    }
  };

  useEffect(() => {
    const itemTypeVal = formData.itemType;
    const variantId = formData.variant;
    const categoryId = formData.category;
    const modelId = formData.model;

    if (
      itemTypeVal
      // &&
      // && variantId
      // && categoryId
      // modelId
    ) {
      fetchItemOptions(itemTypeVal, variantId, categoryId, modelId);
    }
  }, [formData.itemType, formData.variant, formData.category, formData.model]);

  const fetchItemOptions = async (
    itemTypeVal,
    variantId,
    categoryId,
    modelId,
  ) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/item/ddlitem',
        {
          itemtype: itemTypeVal,
          // variant_id: variantId || 0,
          category_id: categoryId || 0,
          model_id: modelId || null,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setaccessoryOptions(options);
    } catch (error) {
      console.error('Error fetching variant options:', error);
    }
  };

  useEffect(() => {
    const accessoryId = formData.accessory;

    if (accessoryId) {
      fetchItemBasedDetails(accessoryId);
    }
  }, [formData.accessory]);

  const fetchItemBasedDetails = async (accessoryId) => {
    const isPopulating = isPopulatingEdit.current;
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/item/ddlitembase',
        { item_id: accessoryId },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const itemData = response?.data?.data?.data[0];
      console.log(itemData, 'itemData');

      if (!isPopulating) {
        setFormData((prevData) => ({
          ...prevData,
          // color: itemData.color_name,
          warranty: itemData.warranty_name,
          basePrice: itemData.purchase_price,
          tax: itemData.tax_percent,
        }));
      }
    } catch (error) {
      console.error('Error fetching variant-based details:', error);
    }
  };

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      itemType: 'V',
    }));
  }, []);

  // useEffect(() => {
  //   // dealer_id
  //   // job_card_no
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     dealerId: jobCardDataDetails.dealer_id,
  //     job_card_number: jobCardDataDetails.job_card_no,
  //   }));
  // },[])

  useEffect(() => {
    if (UserType === 'engineeruser') {
      setFormData((prevData) => ({
        ...prevData,
        dealerId: jobCardDataDetails?.dealer_id,
        job_card_number: jobCardDataDetails?.job_card_no,
      }));
    }
  }, [UserType, jobCardDataDetails]);

  useEffect(() => {
    fetchModelOptions();
  }, []);

  const fetchModelOptions = async (makeId) => {
    try {
      const payload = {
        orderBy: 'model_id desc',
        page: 0,
        pageSize: 100,
      };

      const response = await axiosInstance.post('/model/ddlmodel', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));

      setModelOptions(options);
    } catch (error) {
      console.error('Error fetching model options:', error);
    }
  };

  useEffect(() => {
    const modelId = formData.model;

    if (modelId) {
      fetchColorOptions(modelId);
    }
  }, [formData.model]);

  const fetchColorOptions = async (modelId) => {
    try {
      const payload = {
        page: 0,
        pageSize: 100,
        model_id: modelId,
      };

      const response = await axiosInstance.post('/color/ddlcolor', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((color) => ({
        label: color.NAME,
        value: color.ID,
      }));

      setColorOptions(options);
    } catch (error) {
      console.error('Error fetching model options:', error);
    }
  };

  // useEffect(() => {
  //   if (formData.itemType) {
  //     setFormData({
  //       itemType: formData.itemType, // Retain only the itemType
  //     });
  //   }
  // }, [formData.itemType]);

  useEffect(() => {
    fetchDealers();
  }, []);

  const fetchDealers = async () => {
    try {
      const response = await axiosInstance.post('/dealer/ddldealer', {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response?.data?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.dealer_id,
        label: dealer.dealer_name,
      }));

      setDealerOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  // Form Inputs
  const POInputs = [
    // UserType
    ...(UserType === 'engineeruser' || UserType === 'businesspartner'
      ? [
          {
            name: 'dealerId',
            label: 'Dealer ',
            placeholder: 'Select Dealer',
            type: 'dropdown',
            options: dealerOption,
            // required: true,
            gridClass: 'col-lg-3',
          },
        ]
      : []),
    {
      name: 'itemType',
      label: 'Item Type',
      placeholder: 'Enter',
      type: 'dropdown',
      options: [
        { value: 'V', label: 'Vehicle' },
        // { value: "A", label: "Accessories" },
        // { value: "S", label: "Spare Part" },
      ].filter(
        (option) => !(UserType === 'engineeruser' && option.value === 'V'),
      ),
      required: true,
      gridClass: 'col-lg-3',
      validation: { required: true },
    },
    {
      // name: "variant",
      name: 'model',
      label: 'Model',
      placeholder: '',
      type: 'dropdown',
      options: modelOptions,
      required: formData.itemType === 'V',
      gridClass: 'col-lg-3',
      validation: { required: formData.itemType === 'V' },
    },
    {
      name: 'color',
      label: 'Color',
      placeholder: 'Color',
      type: 'dropdown',
      options: colorOptions,
      // disabled:true,
      gridClass: 'col-lg-3',
      required: true,
      validation: { required: true },
    },

    ...(formData.itemType === 'V'
      ? [
          {
            // name: "variant",
            name: 'variant',
            label: 'Variant',
            placeholder: '',
            type: 'dropdown',
            options: variantOptions,
            required: true,
            gridClass: 'col-lg-3',
            validation: { required: true },
          },
        ]
      : []),

    // ...( formData.itemType !== "V"
    //   ?
    //   [
    //   {
    //       name: "category",
    //       label: "Category",
    //       placeholder:"",
    //       type: "dropdown",
    //       options:itemCategoryOption,
    //       required: true,
    //       gridClass: "col-lg-3",
    //       validation: { required: true },

    //     },
    // ]: []
    // ),
    ...(formData.itemType !== 'V'
      ? [
          {
            name: 'accessory',
            label: 'Item Name',
            placeholder: '',
            type: 'dropdown',
            options: accessoryOptions,
            required: true,
            gridClass: 'col-lg-3',
            validation: { required: true },
          },
        ]
      : []),

    // {
    //     name: "warranty",
    //     label: "Warranty",
    //     placeholder: "Warranty",
    //     type: "text",
    //     disabled:true,
    //     gridClass: "col-lg-3",
    //   },
    {
      name: 'quantity',
      required: true,
      label: 'Request Quantity',
      placeholder: 'Enter Quantity',
      type: 'text',
      gridClass: 'col-lg-3',
      validation: {
        required: true,
        // Only positive integers, no decimals, no leading zeros
        pattern: /^[1-9][0-9]*$/,
        message: 'Quantity must be a whole positive number',
        maxLength: 5,
      },
    },
    {
      name: 'basePrice',
      label: 'Base Price',
      placeholder: 'Base Price',
      type: 'text',
      disabled: true,
      gridClass: 'col-lg-3',
    },
    {
      name: 'tax',
      label: 'GST (%)',
      placeholder: 'Enter GST',
      type: 'text',
      // disabled:true,
      gridClass: 'col-lg-3',
      required: 'true',
      disabled: true,
    },
    {
      name: 'basePricewithGst',
      label: 'Base Price With GST',
      placeholder: 'Enter Base Price with GST Amount',
      type: 'text',
      disabled: true,
      gridClass: 'col-lg-3',
      //required:"true"
    },
    {
      name: 'taxamount',
      label: 'GST Amount',
      placeholder: 'Enter GST Amount',
      type: 'text',
      disabled: true,
      gridClass: 'col-lg-3',
      //required:"true"
    },
    {
      name: 'totalAmount',
      label: 'Total Amount',
      placeholder: 'Enter Total Amount',
      type: 'text',
      disabled: true,
      gridClass: 'col-lg-3',
      //required:"true"
    },
    // {
    //   name: "job_card_number",
    //   label: "Job Card No",
    //   placeholder: "Job Card No",
    //   type: "text",
    //   // disabled:true,
    //   gridClass: "col-lg-3",
    //   //required:"true"
    // },
    // {
    //   name: "remark",
    //   label: "Note",
    //   placeholder: "Enter Remark",
    //   type: "text",
    //   disabled: true,
    //   gridClass: "col-lg-3",
    //   //required:"true"
    // },
  ];

  // Table Data
  const TABLE_HEADERS = [
    // "PO Draft No.",
    'Variant Name',
    'Color',
    'Item Name',
    'ProductImage',
    'Item Type',
    // "Category Name",
    'Quantity',
    'Rate (₹)',
    'Tax (%)',
    'Variant Remark',
    'Tax Amount (₹)',
    'Total Amount (₹)',
    // "Job Card Number",
    'Action',
  ];

  const itemKeyMapping = {
    'PO Draft No.': 'podraft_number',
    'Variant Name': 'NAME',
    Color: 'color_name',
    'Item Name': 'item_name',
    ProductImage: 'productimage',
    'Item Type': 'itemtype_name',
    'Category Name': 'part_category_name',
    Quantity: 'quantity',
    'Rate (₹)': 'baseprice',
    'Tax (%)': 'tax_percent',
    'Variant Remark': 'variant_remark',
    'Tax Amount (₹)': 'taxamount',
    'Total Amount (₹)': 'totalamount',
    'Job Card Number': 'job_card_number',
    Action: [
      { type: 'edit', icon: editIcon, label: 'Edit' },
      { type: 'delete', icon: deleteIcon, label: 'Delete' },
    ],
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  // const handleEdit = (rowData) => {
  //   setIsEdit(true);
  //   setDraftId(rowData.po_draft_id);
  //   getDetailsEdit(rowData.po_draft_id);
  //   getDetailsEdit(rowData.po_draft_id);
  //   getDetailsEdit(rowData.po_draft_id);

  // };
  const handleEdit = async (rowData) => {
    setIsEdit(true);
    setDraftId(rowData.po_draft_id);
    isPopulatingEdit.current = true;

    await getDetailsEdit(rowData.po_draft_id);
    
    setTimeout(() => {
      isPopulatingEdit.current = false;
    }, 1000);
  };

  const handleFormSave = async (formData) => {
    // const errors = {};
    // let isValid = true;

    // POInputs.forEach((field) => {
    //   if (field.validation && field.validation.required) {
    //     if (!formData[field.name]) {
    //       errors[field.name] = "This field is required";
    //       isValid = false;
    //     }
    //   } else if (
    //     field.required &&
    //     field.validation &&
    //     field.validation.pattern &&
    //     !field.validation.pattern.test(formData[field.name])
    //   ) {
    //     errors[field.name] = field.validation.message;
    //     isValid = false;
    //   }
    // });

    // if (!isValid) {
    //   setValidationErrors(errors);
    //   return;
    // }

    if (!isFormValid(POInputs, formData, validationErrors)) {
      const errors = {};
      POInputs.forEach((field) => {
        const value = formData[field.name];
        if (field.validation?.required && !value) {
          errors[field.name] = 'This field is required';
        }
        if (
          value &&
          field.validation?.pattern &&
          !field.validation.pattern.test(value)
        ) {
          errors[field.name] = field.validation.message;
        }
      });
      setValidationErrors(errors);
      return;
    }

    try {
      const payload =
        formData.itemType === 'V'
          ? {
              variant_id: formData.variant, // Pass variant_id for Vehicle
              color_id: formData.color,
              model_id: formData.model,
              variant_remark: remarkData || '',
            }
          : formData.itemType === 'A' || formData.itemType === 'S'
            ? {
                item_id: formData.accessory, // Pass item_id for Accessory or Spare Part
                model_id: formData.model,
                variant_remark: null,
                // dealer_id:formData.dealerId
              }
            : {};
      if (UserType === 'engineeruser' || UserType === 'businesspartner') {
        payload.dealer_id = formData.dealerId;
      }

      payload.quantity = formData.quantity;
      payload.itemtype = formData.itemType;
      payload.job_card_number = formData.job_card_number;

      const url = isEdit
        ? `/podraftdetails/update/${draftId}`
        : '/podraftdetails/create';

      const method = isEdit ? 'patch' : 'post';

      const response = await axiosInstance({
        method, // Dynamically set the HTTP method
        url,
        data: payload,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        setFormData({});
        fetchTableList();
        setIsEdit(false);
      }
    } catch (error) {
      console.log(error, 'error');
    }
  };

  useEffect(() => {
    fetchTableList();
  }, []);

  // fetching table data
  const fetchTableList = async (page = 0, pageSize = 10) => {
    try {
      // setLoading(true)
      const response = await axiosInstance.post(
        '/podraftdetails/list',
        {
          orderBy: 'po_draft_id desc',
          page,
          pageSize,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const formattedData = response?.data?.data?.map((item, index) => ({
        ...item,
        'Sr No.': index + 1 + page * pageSize,
        variant_name: item.variant_name || '--',
        productimage: item.productimage || '--',
        part_category_name: item.part_category_name || '--',
        job_card_number: item.job_card_number || '--',
        item_name: item?.item_name || '--',
      }));
      console.log('formattedData:', formattedData);

      setProductData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error('Error fetching product list:', error);
    } finally {
      // setLoading(false)
    }
  };

  const getDetailsEdit = async (poDraftId) => {
    console.log(poDraftId, 'poDraftId');
    try {
      // setLoading(true)
      const response = await axiosInstance.get(
        `/podraftdetails/edit/${poDraftId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const fetchedData = response.data?.data?.data[0];
      console.log(fetchedData, 'getEditData');

      setFormData((prevData) => ({
        ...prevData,
        itemType: fetchedData?.itemtype,
        warranty: fetchedData?.warranty_name,
        basePrice: fetchedData?.baseprice,
        quantity: fetchedData?.quantity,
        tax: fetchedData?.tax_percent,
        totalAmount: fetchedData?.totalamount,
        taxamount: fetchedData?.taxamount,
        basePricewithGst: (() => {
          const bp = parseFloat(
            String(fetchedData?.baseprice || '0').replace(/,/g, ''),
          );
          const tax = parseFloat(
            String(fetchedData?.tax_percent || '0').replace(/%/g, ''),
          );
          return !isNaN(bp) && !isNaN(tax)
            ? (bp * (1 + tax / 100)).toFixed(2)
            : '';
        })(),
        accessory: fetchedData?.item_id,
        category: fetchedData?.category_id,
        variant: fetchedData?.variant_id,
        color: fetchedData?.color_id,
        model:
          fetchedData?.itemtype === 'V'
            ? fetchedData?.varint_model_id
            : fetchedData?.item_model_id,
      }));
    } catch (error) {
      console.error('Error fetching product list:', error);
    } finally {
      // setLoading(false)
    }
  };

  const handleDelete = async (rowData) => {
    console.log('clicked', rowData);
    try {
      const response = await axiosInstance.get(
        `/podraftdetails/deactivePodraftsorder/${rowData.po_draft_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200) {
        console.log('Item deleted successfully');
        fetchTableList();
      } else {
        console.error('Failed to delete item');
      }
    } catch (error) {
      console.error('Error deleting item:', error);
    }
  };

  // const handleDateChange = (e) => {
  //   const value = e.target.value;
  //   const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

  //   // Check if input matches the dd/mm/yyyy format
  //   if (value === '' || dateRegex.test(value)) {
  //     setExpectedDate(value);
  //   }
  // };

  useEffect(() => {
    if (isPopulatingEdit.current) return;
    console.log('ItemType changed:', formData?.itemType);
    setFormData((prev) => ({
      ...prev,
      model: null,
      color: null,
      variant: null,
      accessory: null,
      quantity: null,
      basePrice: null,
      tax: null,
      totalAmount: null,
      taxamount: null,
      basePricewithGst: null,
    }));
  }, [formData?.itemType]);

  useEffect(() => {
    if (isPopulatingEdit.current) return;
    setColorOptions([]);
    setVariantOptions([]);
    setFormData((prevData) => ({
      ...prevData,
      variant: null,
      color: null,
      basePrice: null,
      tax: null,
      totalAmount: null,
      taxamount: null,
      basePricewithGst: null,
    }));
  }, [formData?.model]);

  useEffect(() => {
    if (isPopulatingEdit.current) return;
    setVariantOptions([]);
    setFormData((prev) => ({
      ...prev,
      variant: null,
    }));
  }, [formData?.color]);

  useEffect(() => {
    if (isPopulatingEdit.current) return;
    if (!formData?.variant && !formData.accessory) {
      setFormData((prev) => ({
        ...prev,
        quantity: null,
        basePrice: null,
        tax: null,
        totalAmount: null,
        taxamount: null,
        basePricewithGst: null,
      }));
    }
  }, [formData?.variant]);

  useEffect(() => {
    if (isPopulatingEdit.current) return;
    if (!formData?.quantity || formData?.quantity === '0') {
      setFormData((prev) => ({
        ...prev,
        totalAmount: null,
      }));
    }
  }, [formData?.quantity]);

  return (
    <div>
      <div
        style={{ paddingTop: '20px', borderBottom: '1px solid lightgray' }}
        className="header-container"
      >
        <div className="backbutton mt-2 mb-2">
          <img src={backicon} alt="back" onClick={() => navigate(-1)} />
          <span className="backbtntitle">New Purchase Order</span>
        </div>

        <div style={{ paddingRight: '12px' }}>
          <button className="submit-btn" onClick={handleDraftSubmit}>
            Save to Draft
          </button>
        </div>
        <div>
          <button className="submit-btn" onClick={handleAcceptModalOpen}>
            Generate Order
          </button>
        </div>
      </div>

      {acceptModal && (
        <div className="customModalOverlay">
          <div className="custom-modal-expectedDate">
            <div className="custom-modal-header">
              <h6 style={{ fontSize: '18px' }}>Dealer Expected Date</h6>
              <button className="close-button" onClick={closeAcceptModal}>
                ×
              </button>
            </div>
            <div className="custom-modal-body">
              <label
                htmlFor="expectedDate"
                style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontWeight: 'bold',
                }}
              >
                Dealer Expected Date
              </label>
              {/* <input
                          type="date"
                          id="expectedDate"
                          value={expectedDate} // Replace `remark` with a new `expectedDate` state
                          onChange={(e) => setExpectedDate(e.target.value)} // Ensure to create `setExpectedDate` for state management
                          style={{padding:"14px", borderRadius:"18px", border:"1px solid gray"}}
                        /> */}
              <div className="input-group">
                <DatePicker
                  ref={(ref) => (datePickerRefs.current['expectedDate'] = ref)}
                  placeholderText="DD/MM/YYYY"
                  selected={
                    expectedDate
                      ? new Date(expectedDate.split('/').reverse().join('-'))
                      : null
                  }
                  onChange={(date) => handleChange('expectedDate', date)}
                  dateFormat="dd/MM/yyyy"
                  className="form-control"
                  popperPlacement="bottom-start"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  minDate={new Date()}
                />
                <span
                  className="input-group-text"
                  onClick={() => openDatePicker('expectedDate')}
                  style={{ cursor: 'pointer' }}
                >
                  <FaCalendarAlt />
                </span>
              </div>
            </div>
            <div className="custom-modal-footer">
              <button
                className="btn btn-primary"
                style={{
                  background: '#7BD755',
                  color: 'white',
                  border: 'none',
                  borderRadius: '20px',
                  padding: ' 10px 28px',
                }}
                onClick={handleSubmit}
              >
                Submit
              </button>
              <button
                className="btn btn-primary"
                style={{
                  background: 'white',
                  color: '#7BD755',
                  border: '1px solid #7BD755',
                  borderRadius: '20px',
                  padding: ' 10px 28px',
                }}
                onClick={closeAcceptModal}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Form */}

      <div
        className="PO-form-container"
        style={{ paddingLeft: '47px', marginTop: '50px', paddingTop: '15px' }}
      >
        <p
          style={{ color: '#000', paddingBottom: '12px', paddingTop: '12px' }}
          className="section-title"
        >
          Add Vehicle
        </p>
        <div>
          <DynamicForm
            formConfig={POInputs}
            formData={formData}
            setFormData={setFormData}
            onSubmit={handleSubmit}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
          />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            gap: '15px',
            paddingTop: '20px',
            alignItems: 'center',
          }}
        >
          <button
            // onClick={() => { handleClaimSubmit(formData)}}
            className="clear-btn"
            style={{ paddingLeft: '35px', paddingRight: '35px' }}
            onClick={() => setFormData({})}
          >
            Reset
          </button>
          <button
            className="submitt-btn"
            disabled={!isFormValid(POInputs, formData, validationErrors)}
            style={buttonStyle(POInputs, formData, validationErrors)}
            onClick={() => {
              handleFormSave(formData);
            }}
          >
            Save
          </button>
        </div>
      </div>

      {/* Custom Table */}

      <div>
        <CustomTable
          data={productData}
          headers={TABLE_HEADERS}
          keyMapping={itemKeyMapping}
          itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onEdit={handleEdit}
          totalRecords={totalRecords}
          handleDelete={handleDelete}
          isADDcomplainTable="true"
        />
      </div>
    </div>
  );
};

export default GenerateOrder;
